import { create } from "zustand"
import type { AuthUser, AuthStatus } from "@/features/auth/types"

interface AuthState {
  user: AuthUser | null
  status: AuthStatus
  /** A sign-in attempt failed and hasn't been dismissed yet — drives the
   *  "Can't log in" toast on the sign-in screen. Fed by both sign-in channels
   *  (popup catch and redirect-result catch), so it works in dev and prod. */
  authError: boolean
  setUser: (user: AuthUser | null) => void
  setAuthError: () => void
  clearAuthError: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: "loading",
  authError: false,
  setUser: (user) => set({ user, status: user ? "authenticated" : "unauthenticated" }),
  setAuthError: () => set({ authError: true }),
  clearAuthError: () => set({ authError: false }),
}))
